import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@env/environment';
import { BreakDetails, BreakList2 } from '@radioking/break';
import moment from 'moment-timezone';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { AddedSlotApi } from '../../../../planning/src/lib/models/planning-api.model';
import {
  BreakDetailsApi,
  BreaksApi,
  convertToAddedBreakApi,
  convertToBreak,
  convertToBreakList,
} from '../models/break-api.model';

const breakUrls = {
  getBreaks: (id: number, from: string, to: string) =>
    `${environment.urls.OLD_MAIN_API}/radio/${id}/schedule/break?from=${from}&to=${to}&limit=1441&offset=0`,
  getBreak: (id: number, breakId: number) =>
    `${environment.urls.OLD_MAIN_API}/radio/${id}/schedule/break/${breakId}`,
  addBreak: (id: number) => `${environment.urls.OLD_MAIN_API}/radio/${id}/schedule/break`,
  editBreak: (id: number, breakId: number) =>
    `${environment.urls.OLD_MAIN_API}/radio/${id}/schedule/break/${breakId}`,
  deleteBreak: (id: number, breakId: number) =>
    `${environment.urls.OLD_MAIN_API}/radio/${id}/schedule/break/${breakId}`,
  deleteBreaks: (id: number) =>
    `${environment.urls.OLD_MAIN_API}/radio/${id}/schedule/break/occurrence`,
  deleteOccurrence: (id: number, breakId: number, occurrenceId: number) =>
    `${environment.urls.OLD_MAIN_API}/radio/${id}/schedule/break/${breakId}/occurrence/${occurrenceId}`,
};
@Injectable({
  providedIn: 'root',
})
export class BreakService {
  constructor(private readonly httpClient: HttpClient) {}

  getBreakList(
    radioId: number,
    radioTz: string,
    from: moment.Moment,
    to: moment.Moment,
  ): Observable<BreakList2> {
    const offset = moment().tz(radioTz).utcOffset();

    return this.httpClient
      .get<BreaksApi>(
        breakUrls.getBreaks(
          radioId,
          from.utc(true).subtract(offset, 'minutes').format(),
          to.utc(true).subtract(offset, 'minutes').subtract(1, 'second').format(),
        ),
      )
      .pipe(map(data => convertToBreakList(data)));
  }

  getBreak(radioId: number, breakId: number): Observable<BreakDetails> {
    return this.httpClient
      .get<BreakDetailsApi>(breakUrls.getBreak(radioId, breakId))
      .pipe(map(data => convertToBreak(data)));
  }

  addBreak(radioId: number, breakObj: BreakDetails): Observable<any> {
    return this.httpClient.post<AddedSlotApi>(
      breakUrls.addBreak(radioId),
      convertToAddedBreakApi(breakObj),
    );
  }

  editBreak(radioId: number, breakObj: BreakDetails): Observable<any> {
    return this.httpClient.put<AddedSlotApi>(
      breakUrls.editBreak(radioId, breakObj.id),
      convertToAddedBreakApi(breakObj),
    );
  }

  deleteBreak(radioId: number, breakId: number, occurrenceId?: number): Observable<any> {
    return this.httpClient.delete(
      occurrenceId
        ? breakUrls.deleteOccurrence(radioId, breakId, occurrenceId)
        : breakUrls.deleteBreak(radioId, breakId),
    );
  }

  deleteSelectedBreaks(radioId: number, breaksId: number[]): Observable<any> {
    return this.httpClient.delete(breakUrls.deleteBreaks(radioId), { body: breaksId });
  }
}
